module.exports = __webpack_public_path__ + "img/default-parlay-amount.64604a27.svg";